export const validateUrl = (url: string, protocol?: boolean): boolean => {
	let pattern
	if (protocol) {
		pattern = new RegExp(
			'^((https:)\\/\\/)' + // protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
			"(\\:\\d+)?(\\/[-a-z\\d%_.-~!$&'()*+,;=:@]*)*" + // port and path
			'(\\?[;&a-z\\d%_.~+=-{}\\/\\:\\.\\-]*)?' + // query string. This allows another URL as a paratemer
				'(\\#[-a-z\\d_{}=]*)?$',
			'i',
		) // fragment locator
	} else {
		pattern = new RegExp(
			'^((https:)\\/\\/)' + // protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
			"(\\:\\d+)?(\\/[-a-z\\d%_.-~!$&'()*+,;=:@]*)*" + // port and path
			'(\\?[;&a-z\\d%_.~+=-{}\\/\\:\\.\\-]*)?' + // query string. This allows another URL as a paratemer
				"(\\#([A-Za-z0-9\\-._~!$&'()*+,;=:@/?]*|(\\%[0-9A-Fa-f]{2}))*$)?", // fragment
			'i',
		)
	}
	return !!pattern.test(url)
}
